import { lazy } from 'react';

import { Navigate, type RouteObject } from 'react-router-dom';

import { type RoutePageMeta } from '../layouts/DashboardLayout/page-meta';

const WalletPage = lazy(() =>
  import('@/domains/wallet/wallet/routes').then(m => ({ default: m.WalletPage }))
);
const ContactsPage = lazy(() =>
  import('@/domains/wallet/contacts/routes').then(m => ({ default: m.ContactsPage }))
);
const TransferPage = lazy(() =>
  import('@/domains/wallet/transfers/routes').then(m => ({ default: m.TransferPage }))
);
const PaymentsPage = lazy(() =>
  import('@/domains/wallet/payments/routes').then(m => ({ default: m.PaymentsPage }))
);
const BatchTransfersPage = lazy(() =>
  import('@/domains/wallet/batch-transfers/routes/BatchTransfersPage').then(m => ({
    default: m.BatchTransfersPage,
  }))
);
const AccountPage = lazy(() =>
  import('@/domains/wallet/accounts/routes').then(m => ({ default: m.AccountPage }))
);
const KYCPage = lazy(() =>
  import('@/domains/identity/kyc/routes').then(m => ({ default: m.KYCPage }))
);

// Page titles + breadcrumbs ride on each route's `handle` (plan 06 L3).
export function walletRoutes(): RouteObject[] {
  return [
    {
      path: '/wallet',
      element: <WalletPage />,
      handle: { titleKey: 'navigation.wallet', namespace: 'common' } satisfies RoutePageMeta,
    },
    {
      path: '/contacts',
      element: <ContactsPage />,
      handle: { titleKey: 'navigation.contacts', namespace: 'common' } satisfies RoutePageMeta,
    },
    {
      path: '/transfer',
      element: <TransferPage />,
      handle: { titleKey: 'navigation.transfers', namespace: 'common' } satisfies RoutePageMeta,
    },
    // Redirect-only — no metadata.
    { path: '/transfers', element: <Navigate to="/transfer" replace /> },
    {
      path: '/payments',
      element: <PaymentsPage />,
      handle: { titleKey: 'navigation.payments', namespace: 'common' } satisfies RoutePageMeta,
    },
    {
      path: '/batch-transfers',
      element: <BatchTransfersPage />,
      handle: {
        titleKey: 'navigation.batchTransfers',
        namespace: 'common',
      } satisfies RoutePageMeta,
    },
    {
      path: '/account',
      element: <AccountPage />,
      handle: { titleKey: 'navigation.accounts', namespace: 'common' } satisfies RoutePageMeta,
    },
    // /kyc has no static title — the page sets its own header dynamically.
    { path: '/kyc', element: <KYCPage /> },
  ];
}
